import React from 'react';
import { useParams } from 'react-router-dom';

import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Buscando from 'Component/Buscando';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import { VinculoEmpregaticioLista } from 'Component/VinculoEmpregaticio';
import { useRecuperarVinculosEmpregaticiosQuery } from 'View/Service/Default/VinculosEmpregaticios';

const Vinculos = (): React.ReactElement => {
  const { id = 0 } = useParams();

  const {
    data: { vinculos, paginacao } = {},
    isFetching,
    isLoading,
    refetch,
  } = useRecuperarVinculosEmpregaticiosQuery({
    contain: ['Empresas', 'Departamentos', 'Funcoes'],
    options: { usuario_id: id },
  });

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-6 mb-3">
          <Botao icone="arrow-clockwise" onClick={refetch} className="me-2" />
          <BotaoLink
            tema="success"
            icone="plus-lg"
            to={`/usuarios/editar/${id}/vinculos/adicionar`}
          >
            Adicionar
          </BotaoLink>
        </div>
      </div>
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={vinculos?.length}
        redirecionar={`/usuarios/editar/${id}/vinculos/adicionar`}
      />
      <div className="bg-white shadow-sm rounded">
        {vinculos?.map((vinculo) => (
          <VinculoEmpregaticioLista
            key={`${vinculo.id}-${vinculo.modificado}`}
            dados={vinculo}
          />
        ))}
      </div>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </React.Fragment>
  );
};

export default Vinculos;
